import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-task-v2-current-location-info',
    templateUrl: './fi-task-v2-current-location-info.component.html',
    styleUrl: './fi-task-v2-current-location-info.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-current-location-info' },
    standalone: false,
})
export class FiTaskV2CurrentLocationInfoComponent {
    @Input({ required: true }) accessToPreferredBusinessUnitMode: boolean;
}
